module.exports = __webpack_public_path__ + "static/media/footwear-4.1d31dbb6.jpg";